/**
 * Getting the outer height (include margins) of an element
 *
 * @param  {DOMNode} element  Element to compute
 */

function getOuterHeight(element) {
    let height = element.offsetHeight;
    const style = getComputedStyle(element);

    height += parseInt(style.marginTop) + parseInt(style.marginBottom);

    return height;
}

function getInnerWidth(element) {
    let width = element.clientWidth;
    const style = getComputedStyle(element);

    width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);

    return width;
}

export {
    getOuterHeight,
    getInnerWidth
};
